module.exports = __webpack_public_path__ + "static/media/num-meaning.36e1352e.svg";